import { useIdsSelect, useIdsSelecting } from '@entities/common/IdsSelector/models.ts';
import { useSaveData } from '@entities/common/savedData/index.ts';
import { useCallback } from 'react';
import { useAppDispatch, useMobile } from '@shared/hooks/index.ts';
import type { Client } from '@shared/types/users';
import { openNotifyModal } from '@src/library/redux/modal/index.ts';

export const useInviteClientModal = () => {
  const dispatch = useAppDispatch();
  const { data, doRemoveStorageData, doSetStorageData } = useSaveData<{ isOpen: boolean }>(
    'inviteClientModalState'
  );

  const openInviteModal = useCallback(() => {
    dispatch(
      openNotifyModal({
        isOnConfirmShouldNotWorkOnCloseModal: true,
        needClose: true,
        title: 'Уведомление',
        text: 'Клиент не является пользователем платформы',
        confirmText: 'Пригласить',
        confirm: () => doSetStorageData({ isOpen: true }),
      })
    );
  }, [dispatch, doSetStorageData]);

  const closeInviteModal = useCallback(() => {
    doRemoveStorageData();
  }, [doRemoveStorageData]);

  return { openInviteModal, closeInviteModal, modalState: data };
};

export const useSelectedClient = () => {
  const {
    data: selectedClient,
    doRemoveStorageData: clearSelectedClient,
    doSetStorageData: setSelectedClient,
  } = useSaveData<Client>('selectedClient');
  return {
    selectedClient,
    clearSelectedClient,
    setSelectedClient,
  };
};

export const useClientIdsSelect = () => {
  const {
    setIsSelectingTrue,
    isSelecting,
    setIsSelectingFalse,
    setIsNeedToSelectAllSelectingFalse,
    setIsNeedToSelectAllSelectingTrue,
    isNeedToSelectAll,
  } = useIdsSelecting('clients');
  const { isMobile } = useMobile();
  const {
    isIdSelected,
    selectedIds,
    doResetSelectedIds,
    doAddId,
    doRemoveId,
    doToggleId,
    excludedIds,
    doResetExcludedIds,
  } = useIdsSelect('clients');

  const toggleSelectAllClients = () => {
    if (excludedIds?.length) {
      doResetExcludedIds([]);
    } else {
      doResetExcludedIds([]);
      doResetSelectedIds([]);
      isNeedToSelectAll
        ? setIsNeedToSelectAllSelectingFalse()
        : setIsNeedToSelectAllSelectingTrue();
    }
  };

  const toggleSelectionMode = () => {
    doResetExcludedIds([]);
    doResetSelectedIds([]);
    setIsNeedToSelectAllSelectingFalse();
    isSelecting ? setIsSelectingFalse() : setIsSelectingTrue();
  };
  const isMobileWithSelecting = isMobile && isSelecting;
  const selectedCount = selectedIds?.length || 0;
  return {
    setIsSelectingTrue,
    isSelecting,
    setIsSelectingFalse,
    isIdSelected,
    selectedIds,
    doResetSelectedIds,
    doAddId,
    doRemoveId,
    doToggleId,
    selectedCount,
    toggleSelectAllClients,
    toggleSelectionMode,
    isNeedToSelectAll,
    excludedIds,
    isMobile,
    isMobileWithSelecting,
  };
};
